module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("THE FIRST CHAPTER")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "C1-1"
    }
  }, [_vm._v("CABEZA DE VACA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nearly half a century before the Pilgrims landed in New England or the Jamestown settlers came to Virginia, a small library of poems and books had been written about the Spanish in Florida.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The adventure of Cabeza de Vaca provided the first look at the interior of the continent. His story became one of the first major accounts of life in North America.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early 1527, de Vaca sailed from Spain as part of an expedition of six hundred men with plans to settle on the Gulf Coast of Florida. Even before they reached Florida, however, they lost nearly a third of their number to storms and desertion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they landed near Tampa Bay, the men began arguing. Some thought there was gold to be found and wanted to search for it. Others wanted to stay with the ships on the coast in case of Indian attacks. The Indians did attack, and only 242 survivors reached Apalachee Bay in the Florida Panhandle. They planned to reconnect with the ship that brought them from Spain but never found it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("De Vaca thought he could find Spanish soldiers in Mexico, and he and his men decided to sail across the Gulf. They built five boats, each able to hold fifty men, and set sail heading west. A violent storm—probably a hurricane—separated the flotilla; only two ships and forty men survived, coming ashore near present-day Galveston. The survivors were enslaved by the Indians, and only four men from the original expedition reached Mexico City.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("De Vaca sailed back to Europe, where he wrote his story, the first book devoted entirely to North America. Because he wrote from memory and was never sure exactly where he had been, his memoirs are full of geographical errors. His book, "), _c('i', [_vm._v("La relación")]), _vm._v(", offered the first account of the Indians of North America. He was sympathetic toward the indigenous people and accurately described them, something later writers seldom did. Even when he returned to Spain, he remained a defender of the natives and railed at the Spanish enslavement of the Indians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His journey inspired later expeditions led by Hernando de Soto and Francisco Coronado. As a reward, the Spanish Crown named him head of the government in Argentina, but his leadership was criticized and he returned to Spain, where he died penniless.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cabeza de Vaca is nearly forgotten in the United States but remains famous in Spain. "), _c('i', [_vm._v("Florida Archives.")])])]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "C1-2"
    }
  }, [_vm._v("ANONYMOUS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first poem about North America was placed in the Bodleian Library at Oxford University in 1564, and the author is unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The poem is titled, “The preme Rose in the grene forest.” The section dealing with Florida is known as “Have You Not Hard of Floryda.” It is unclear whether this was one poem or two poems cobbled together. Also unknown is when the stanzas were written, whether others were added and if some may have been lost. It is thought that stanzas four and five may be from a poem written later and inserted into this one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is the first poetic commentary on Florida and the first recorded poem written about North America. The poem is written in English, and it is doubtful that it could have been written by a member of either the Spanish or French expeditions of the sixteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Spanish expeditions at one point claimed lands as far north as president-day Virginia, and it is possible an English expedition was referring to those lands. Florida did not get its name until 1513, when Ponce de Leon sailed along the coast.")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And as I walked toward s poles")]), _vm._v(" [St. Pauls]")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("I met a frend of myne,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Who toke")]), _vm._v(" [me] "), _c('i', [_vm._v("by the hand and sayde,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“Com drynk a pynt of wyne,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Wher you shall here")]), _vm._v(" [hear]")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Such news, I fere,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("As you abrode wyll compell.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("with hy!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('i', [_vm._v("Have you not hard of floryda,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("A coontre far bewest,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Where savage pepell planted are")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("By nature and by hest,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Who in the mold")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Fynd glysterynge gold")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("and yt for tryfels sell?")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("with hy!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('i', [_vm._v("Ye all alonge the watere side,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Where yt doth eb and flowe,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Are turkeyse founde and where also")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Do perles in oysteres growe,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And on the land")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Do cedars stand")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Whose bewty do")]), _vm._v("[th] "), _c('i', [_vm._v("excel.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("with hy!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("trysky, trym, go trysky, wun not a wallet do well?")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('i', [_vm._v("The prymerose in the greene forest,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("The vyolets the grow gaye,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("The Dubbell Dayses with the rest")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("So merryly deks the waye")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("To moove my Sprytes")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Through fond delyghts")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Lyke pretty wons as the be.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("with hy!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('i', [_vm._v("The sweete record, the nytyngale,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("The leveret and the thrushe,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Which whyps & skyps & wages there tales")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("From every bank to busshe")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And chyrpyngly")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Do pas the day")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Like prety wond as the be.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('i', [_vm._v("Have over the water to floryda,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Farewell, gay lundon, nowe,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Throw long deles by land and sese,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("I am brawght, I cannot tell howe,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("To plymwoorthe towne")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("In a thredbare goowne")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("and mony never Dele")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("with hy!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("wunnot a wallet do well?")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('i', [_vm._v("When Aprell sylver showers so sweet")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Can make may flowers to sprynge")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And every pretty byrd prepars")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Her wystlyng throte to synge,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("The nyghtyngale")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("In every Dale")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("They doth ther duty well.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("with hy!")])])]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "C1-3"
    }
  }, [_vm._v("NICOLAS LE CHALLEUX")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While a vast library of writings by Spanish writers survives, the French presence in Florida was brief and bloody. The Spanish came to Florida first but expressed little interest in colonizing an area with no mineral wealth. That changed with the arrival of the French. The Spanish Catholics would not allow French Protestants to convert the Native Americans to Protestantism, and the Spanish wanted a site on Florida’s east coast to protect their gold-laden ships sailing for Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two sides were destined to clash after the French built Fort Caroline near present-day Jacksonville.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The French sailed for St. Augustine to confront the Spanish, but their ship was caught in a storm and the French soldiers washed ashore, where the waiting Spanish put them to death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicolas Le Challeux came to Florida with the French expedition and was one of the few survivors. He escaped and returned to France, where he wrote a poem that summarized his time in Florida:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Whoever wishes to go to Florida,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Let him go where I have been.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And return dry and arid,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And worn out by rot.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("For the only good I have brought back—")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("A single silvery stick in my hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("But I am safe, not defeated:")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("It’s time to eat; I die of hunger.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His primary contribution was a book about the French struggles in Florida, which includes his vivid description of the slaughter by the Spanish. The book, "), _c('i', [_vm._v("Nicolas Le Challeux’s Narrative of Captain Jean Ribault’s Last Voyage in 1565, Undertaken at the King’s Command, to an Island in the Indies Commonly Called Florida")]), _vm._v(", is the first history of Florida. The book was published in France in 1566 shortly after Challeux returned.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "C1-4"
    }
  }, [_vm._v("ALONSO GREGORIO DE ESCOBEDO")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("De Vaca was not the only friend the Indians found among the early Spanish. Friar Alonso Gregorio de Escobedo arrived in St. Augustine in 1587 and immediately began writing about what he saw. His poem contains 21,000 lines filling 449 pages. The work has never been published and has been read by only a few in the Biblioteca Nacional in Madrid. He writes in a stream of consciousness and jumps from one topic to another, making it almost impossible to understand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One minute he is writing about Indian fishing and the next composing one of his sermons, followed by an account of his day in Florida. It is unfortunate his writings have not received more attention, since he does provide an honest look at life in Florida and, like De Vaca, is sympathetic to the Indians.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "C1-5"
    }
  }, [_vm._v("JUAN DE CASTELLANOS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Juan de Castellanos was born in 1522, one year after Juan Ponce de Leon died, yet it is Castellanos who became the source for myths about Ponce and the Fountain of Youth. Castellanos arrived in Puerto Rico in the 1540s and began writing poetry—a total of 113,000 lines in four volumes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Castellanos devotes most of his poem to Ponce discovering Florida, but it was the section on the Fountain of Youth that captivated the world. Bimini is a small island off the southeast coast of Florida, although it shows up often in Spanish literature and could mean Florida itself or a nearby island.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The myth of the Fountain of Youth began nearly 2,500 years ago, beginning with Herodotus, who said it was in Somalia. Later it was said to be in Asia, and by the twelfth century it was said to have been found by the Crusaders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Parts of Castellanos’s work were published in 1589, but it was another 250 years before they were all published. He wrote a poem linking Ponce to the fountain:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Amongst the most ancient of their people,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("There were many Indians who said that on Bimini, a powerful island")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And center for many different nations, there exists a fountain with great virtues")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("From which older men became young again")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("And where elderly women walked away")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("With wrinkles smoothed over and hair not grey.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the poem did not claim Ponce found a Fountain of Youth, it linked him forever with the fountain. Over the past four centuries, there have been various claims about the location in Florida. An attraction in St. Augustine claims to be the real Fountain of Youth, but dozens of other sites have made similar claims.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "C1-6"
    }
  }, [_vm._v("JONATHAN DICKINSON")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jonathan Dickinson had no intention of coming to Florida in 1696 when he and his family sailed from Jamaica bound for Philadelphia. Dickinson, his wife, their infant son and ten slaves set off on the "), _c('i', [_vm._v("Reformation")]), _vm._v(" as part of a convoy. Their ship became separated from the rest, and after three weeks, a violent storm struck and their ship ran aground at what is now Hobe Sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were confronted by the Jaega Indians, who stole their provisions and took them prisoner. At Jupiter Inlet, the Indians burned their ship, sparing only a lifeboat, then released the party except for a young slave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They split into two groups; the children and sick were put into the lifeboat and rowed up the coast while the rest walked along the shore. A second tribe, the Ais Indians, took them next and continued their journey. At Vero Beach, they were surprised to find a friendly welcome, and the Indians allowed them to send one member of the party to St. Augustine to seek help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On November 2, Spanish soldiers arrived, but it was not quite the salvation they sought. The journey to St. Augustine was difficult, and five died of exposure and hunger. The Spanish gave them boats for the journey to Charles Town, South Carolina, and they finally reached Philadelphia seven months after they left Port Royal.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dickinson’s book has remained in print for more than three hundred years. "), _c('i', [_vm._v("Yale University Press.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dickinson wrote about his ordeal in what became known as "), _c('i', [_vm._v("Jonathan Dickinson’s Journal")]), _vm._v(", which is a short version of one of the longest titles in literature:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("God’s Protecting Providence Man’s Surest Help and Defence in the Times of the Greatest Difficulty and Most Imminent Danger Evidenced in the Remarkable Deliverance of Robert Barrow, With Divers Other Persons, from the Devouring Waves of the Sea, amongst which They Suffered Shipwreck. And also, From the Cruel Devouring Jaws of the Inhumane Canibals")]), _vm._v(" [sic] "), _c('i', [_vm._v("of Florida. Faithfully Related by One of the Persons Concerned Therein, Jonathan Dickinson.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he reached Philadelphia, seven months after sailing from Jamaica, he published his story in a thin volume. It quickly became a huge success, giving many their first detailed look at Florida and the Indian tribes. The "), _c('i', [_vm._v("Cambridge History of English and American Literature")]), _vm._v(" called it “in many respects the best of all the captivity tracts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not only a rousing adventure story, but the Quakers also saw it as an inspirational story because Dickinson did not use force, despite the dangers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Earlier works were written in Spanish and French, and for many in England, this was their first look at Florida. The tract was reprinted in English sixteen times and went through multiple printings in Dutch and German. Dickinson became one of Philadelphia’s leading citizens, serving two terms as mayor and accumulating vast wealth.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 69
// module chunks = 0